var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_8317)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5733 1.39356L7.72885 11.1529C7.67148 11.2988 7.56955 11.4229 7.43757 11.5075C7.30559 11.5922 7.15027 11.633 6.99374 11.6242C6.83721 11.6155 6.68743 11.5576 6.56572 11.4587C6.44401 11.3599 6.35657 11.2252 6.31585 11.0738L5.1706 6.82956L0.926348 5.68431C0.77495 5.64359 0.640253 5.55615 0.541428 5.43444C0.442604 5.31273 0.384687 5.16295 0.375922 5.00641C0.367156 4.84988 0.407988 4.69457 0.492607 4.56259C0.577225 4.43061 0.701318 4.32868 0.847223 4.27131L10.6066 0.426807C10.7417 0.373624 10.8894 0.361054 11.0316 0.39064C11.1737 0.420226 11.3041 0.490681 11.4068 0.593352C11.5095 0.696024 11.5799 0.826443 11.6095 0.968596C11.6391 1.11075 11.6265 1.25845 11.5733 1.39356Z",
    fill: "#D94E00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_8317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOrange);
export default __webpack_public_path__ + "static/media/Arrow-orange.1e5c000521aebe7a049ec861ef5cc0b2.svg";
export { ForwardRef as ReactComponent };